<template>
  <div class="big-map-box">
    <div class="map-content" id="rangeMap"></div>
    <div class="map-darkcorner"></div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'AmapRange',
  props: {
    title: {
      type: String,
      default: ''
    },
    legendColor: {
      type: Array
    },
    chartData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      chart: null,
      map: null
    }
  },
  mounted() {
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      // 先根据value洗颜色
      for (let i = 0; i < this.chartData.sourceArea.length; i++) {
        if (!this.chartData.sourceArea[i].hasOwnProperty('coordinate')) {
          continue
        }
        if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[0].min
        ) {
          this.chartData.sourceArea[i].color = this.legendColor[0]
        } else if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[1].min
        ) {
          this.chartData.sourceArea[i].color = this.legendColor[1]
        } else if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[2].min
        ) {
          this.chartData.sourceArea[i].color = this.legendColor[2]
        }
      }
      // 洗series
      var series = []
      for (let i = 0; i < this.chartData.sourceArea.length; i++) {
        if (!this.chartData.sourceArea[i].hasOwnProperty('coordinate')) {
          continue
        }
        series.push({
          name: this.chartData.sourceArea[i].name,
          coordinateSystem: 'amap',
          type: 'lines',
          zlevel: 3,
          effect: {
            show: true,
            period: 6,
            shadowBlur: 4,
            trailLength: 0.4,
            opacity: 0.6,
            color: this.chartData.sourceArea[i].color,
            symbolSize: 4
          },
          lineStyle: {
            normal: {
              color: this.chartData.sourceArea[i].color,
              width: 0
            }
          },
          data: [
            {
              fromName: this.chartData.curArea,
              toName: this.chartData.sourceArea[i].name,
              coords: [
                this.chartData.curCenter,
                this.chartData.sourceArea[i].coordinate
              ],
              value: this.chartData.sourceArea[i].value
            }
          ]
        })
        series.push({
          name: this.chartData.sourceArea[i].name,
          coordinateSystem: 'amap',
          type: 'lines',
          zlevel: 2,
          lineStyle: {
            normal: {
              color: this.chartData.sourceArea[i].color,
              width: 1.5,
              opacity: 0.6,
              shadowColor: this.chartData.sourceArea[i].color,
              shadowBlur: 10
            }
          },
          data: [
            {
              fromName: this.chartData.curArea,
              toName: this.chartData.sourceArea[i].name,
              coords: [
                this.chartData.curCenter,
                this.chartData.sourceArea[i].coordinate
              ],
              value: this.chartData.sourceArea[i].value
            }
          ]
        })
        series.push({
          name: this.chartData.sourceArea[i].name,
          type: 'effectScatter',
          coordinateSystem: 'amap',
          zlevel: 4,
          symbol: 'circle',
          symbolSize: 2,
          rippleEffect: {
            scale: 8,
            period: 6,
            brushType: 'fill'
          },
          label: {
            normal: {
              show: true,
              position: 'bottom',
              formatter: () => {
                return (
                  this.chartData.sourceArea[i].name +
                  ' ' +
                  this.chartData.sourceArea[i].num
                )
              },
              color: '#cbeeff'
            }
          },
          itemStyle: {
            normal: {
              color: this.chartData.sourceArea[i].color
            }
          },
          data: [
            {
              name: this.chartData.sourceArea[i].name,
              value: this.chartData.sourceArea[i].coordinate
            }
          ]
        })
      }

      this.chart = this.$echarts.init(document.getElementById('rangeMap'))
      this.chart.setOption({
        amap: {
          zoom: 6,
          zooms: [4, 10],
          mapStyle: 'amap://styles/b5500447492ee5d38f79824b6e68aec4',
          center: [113.814572, 33.871112], //中心点
          rotation: 0, //顺时针旋转角度
          resizeEnable: true
        },
        animation: false,
        series: []
      })

      this.map = this.chart
        .getModel()
        .getComponent('amap')
        .getAMap()
      this.chart.setOption({
        series: series
      })

      setTimeout(() => {
        this.legendColor.forEach((el, index) => {
          new AMap.Circle({
            map: this.map,
            center: this.chartData.curCenter, //设置线覆盖物路径
            radius: this.chartData.legendConf[index].max * 1000,
            strokeColor: this.legendColor[index], //边框线颜色
            strokeOpacity: 0.8, //边框线透明度
            strokeWeight: 2, //边框线宽
            fillColor: this.legendColor[index], //填充色
            fillOpacity: (index + 1) * 0.08, //填充透明度
            index: 0,
            zIndex: (index + 1) * 10
          })
        })
        this.map.setFitView()
      }, 100)
    }
  }
}
</script>

<style scoped lang="less">
.big-map-box {
  .map-darkcorner {
    box-shadow: 0 0 5rem 3rem rgba(0, 0, 0, 0.6) inset;
  }
}
</style>
